/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { getCompanyNameFromUrl } from "lib/utils";
import { useHistory } from "react-router-dom";
import getMyTenants from "lib/requests/me";
import { useDispatch } from "react-redux";
import { find as _find } from "lodash";
import { mixpanelBase } from "app/common/MixpanelComponent";
import { setTenant } from "./duck/slices";
import LoginComponent from "./LoginComponent";
import FormTitle from "./utils/FormTitleComponent";
import LoadingSpinner from "./utils/LoadingSpinnerComponent";
import AlertMessage from "./utils/AlertMessageComponent";
import TenantSelectorForm from "./utils/TenantSelectorFormComponent";

export default function TenantSelectorComponent({ options, message }) {
  const [isLoading, setIsLoading] = React.useState(true);
  const [alertMessage, setAlertMessage] = React.useState(message);
  const [tenants, setTenants] = React.useState(options);
  const dispatch = useDispatch();
  const history = useHistory();

  const getTenants = async () => {
    setIsLoading(true);
    const tenantsList = (await getMyTenants()).data;

    const company = getCompanyNameFromUrl(window.location.href);
    if (company) {
      // Remove dash '-' before checking the company name
      const tenant = _find(
        tenantsList,
        (t) => t.mysql_database === company.replace("-", "")
      );

      if (tenant) dispatch(setTenant(tenant));
      else
        history.push({
          pathname: "/logout",
          state: {
            message: "You are not authorized to access this data",
          },
        });

      return;
    }

    switch (tenantsList.length) {
      case 0:
        setAlertMessage(
          "There are no data instances available for you. If this is an error, please contact with the support team"
        );
      // falls through
      case 1:
        // If the user only has access to one tenant, select it by default
        dispatch(setTenant(tenantsList[0]));
        mixpanelBase({
          [`data_instance`]: tenantsList[0]?.mysql_database,
        });
        return;
      default:
        setIsLoading(false);
        setTenants(tenantsList);
    }
  };

  useEffect(() => {
    if (!tenants) getTenants();
    else setIsLoading(false);
  }, []);

  return (
    <LoginComponent
      dividerLinkTo="/logout"
      dividerLinkText="Sign out"
      showLinks={!isLoading}
    >
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <FormTitle>Select a data instance</FormTitle>
          {alertMessage && <AlertMessage message={alertMessage} />}
          {tenants && !!tenants.length && (
            <TenantSelectorForm
              setAlertMessage={setAlertMessage}
              setIsLoading={setIsLoading}
              tenants={tenants}
            />
          )}
        </>
      )}
    </LoginComponent>
  );
}
